<template>
  <busstop-select v-model="selected" isEnableAttribute="enableDropOff" :setDefaultBusstop="setDefaultBusstop" />
</template>

<script>
import BusstopSelect from './TentativeBusstopSelect'

export default {
  components: {
    BusstopSelect
  },
  computed: {
    selected: {
      get () {
        return this.$store.getters['reservation/getArrival']
      },
      set (busstop) {
        this.$store.dispatch('reservation/selectArrival', busstop)
      }
    }
  },
  methods: {
    setDefaultBusstop: function (busstop) {
      this.$store.dispatch('reservation/selectArrival', busstop)
    }
  }
}
</script>
